import Cookies from 'js-cookie';

export default class CookieBar {
    constructor() {
        this.cookie = Cookies.get('cookiemessage');
        this.bar = document.querySelector('[data-cookie-bar]');

        if (!this.bar) {
            return;
        }

        this.acceptButton = this.bar.querySelector('[data-cookie-bar-accept]');
        this.declineButton = this.bar.querySelector('[data-cookie-bar-decline]');

        if (!this.cookie) {
            this.acceptButton.addEventListener('click', this.accept.bind(this));
            this.declineButton.addEventListener(
                'click',
                this.decline.bind(this),
            );
            this.show();
        } else {
            this.bar.remove();
        }
    }

    show() {
        this.bar.classList.add('active');
    }

    hide() {
        this.bar.classList.remove('active');
    }

    accept() {
        Cookies.set('cookiemessage', 'accepted', { expires: 365 });
        this.hide();
    }

    decline() {
        Cookies.set('cookiemessage', 'declined');
        this.hide();
    }
}
